<script setup lang="ts">
  import type { Country } from '@/models/types';
  import { PropType } from 'vue';

  defineProps({
    selectedCodePhone: {
      type: Object as PropType<Country>,
    },
    index: {
      type: Number,
      default: 0,
    },
    phone: {
      type: String,
    },
  });
</script>

<template>
  <div
    v-if="selectedCodePhone?.iso3 === 'USA' && !!phone"
    class="flex flex-col gap-2"
  >
    <div class="p-4 rounded-xl bg-orange-100">
      <p class="bold text-justify mb-2">
        {{ $t('modal.diffusion.warning_sms.bold') }}
      </p>
      <p class="text-justify">
        {{ $t('modal.diffusion.warning_sms.text') }}
      </p>
    </div>
    <label
      :for="`confirm-us-${index}`"
      class="h-10 rounded-md self-start p-2 cursor-pointer hover:bg-ternary focus-within:bg-ternary flex items-center"
    >
      <input
        type="checkbox"
        :id="`confirm-us-${index}`"
        :name="`confirm-us-${index}`"
        :required="true"
      />
      <small class="ml-2"> {{ $t('modal.diffusion.warning_sms.confirm') }} </small>
    </label>
    <small class="ml-7"
      >Privacy Policy:
      <a
        class="text-primary hover:underline"
        href="https://roadbook.travel/privacy-policy"
        target="_blank"
        >https://roadbook.travel/privacy-policy</a
      ></small
    >
  </div>
</template>
